import 'es6-object-assign/auto';
import debounce from 'lodash/debounce';

import template from './card-view.vhtml';
import QdCard from '../card/card.js';

export default {
	template,
	props: {
		postType: {
			type: String,
			default: '',
		},
		filters: {
			type: Object,
			default: false,
		},
	},
	data() {
		return {
			cards: [],
			isLoading: false,
		};
	},
	watch: {
		filters: function() {
			this.reload();
		},
	},
	methods: {
		reload: debounce( function() {
			this.isLoading = true;
			getItems( this.postType, this.filters )
                .then( items => {
					if ( items ) {
						this.cards = items;
					}
				})
                .always( () => this.isLoading = false );
			}, 500 ),
	},
	created() {
		this.reload();
	},
	components: {
		QdCard,
	},
};

/**
 * Gets resumes from WP REST API
 *
 * @param {string} post_type
 * @param {string} [search=""]
 * @returns {JQueryPromise<any>}
 */
function getItems( postType = '', filters ) {
	const params = {
		'post_type': postType,
		'easv_education_subject_areas': filters.easv_education_subject_areas,
		'easv_location_tag': filters.easv_location_tag,
		'easv_education_language': filters.easv_education_language,
		'easv_education_level': filters.easv_education_level,
		'easv_education_economy': filters.easv_education_economy,
		'easv_education_duration': filters.easv_education_duration,
		'scheduled_subjects': filters.scheduled_subjects,
		'available_seats': filters.available_seats,
		'search_str': filters.search_str,
		'lang': window.siteData.language,
	};

	return $.get( `/wp-json/easv/v1/education`, params );
}



// WEBPACK FOOTER //
// ./assets/_js/components/card-view/card-view.js